import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, ContainerContent } from '@/component';
import { ExternalStoragePageContent } from '@/component/ExternalStorage';
import { useMainLayout } from '@/provider';

const LinkExternalStoragePage = () => {
  const { setTitle } = useMainLayout();
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(t('storage.linkExternalStorage.saviorhood'));
  }, []);

  return (
    <Container>
      <ContainerContent>
        <ExternalStoragePageContent />
      </ContainerContent>
    </Container>
  );
};

export default LinkExternalStoragePage;
